import useUniquePrefix from "../../../hooks/useUniquePrefix";
export var getPanelId = function(idPrefix, value) {
    if (idPrefix) {
        return "".concat(idPrefix, "-panel-").concat(value);
    }
};
export var getTabId = function(idPrefix, value) {
    if (idPrefix) {
        return "".concat(idPrefix, "-tab-").concat(value);
    }
};
export { useUniquePrefix };
export default useUniquePrefix;
